// extracted by mini-css-extract-plugin
module.exports = {"container":"WebstoreHeader_container__WEjd2","title":"WebstoreHeader_title__yi4Dd","subtitle":"WebstoreHeader_subtitle__gkmkn"};